<template>
    <div>
        <el-form :model="loginForm" :rules="rules" ref="loginForm" label-position="left" label-width="0px"  id="login_from" class="demo-ruleForm login-container"
                 @keyup.native.enter="handleSubmit" style="background-color: white;">
            <div class="login_border">
                <div class="login_info">
                    <h3 class="title" v-if="isHkServer && systemCpy==1"><img src="../assets/home.png"/></h3>
                    <h3 class="title" v-if="isHkServer && systemCpy==2"><img src="../assets/blueoak/logo2.png"/></h3>
                    <el-form-item prop="name" >
                        <el-input type="text"  v-model="loginForm.name" id="loginName" auto-complete="off"  placeholder="帳號" >
                            <el-button slot="prepend" class="login_form_button"><i class="fa fa-user-circle"/></el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="password" v-if="loginForm.name!=null && loginForm.name!=''">
                        <el-input type="password"   id="password" v-model="loginForm.password"
                                  auto-complete="off" placeholder="密碼" >
                            <el-button slot="prepend" class="login_form_button"><i class="fa fa-lock"/></el-button>
                        </el-input>
                    </el-form-item>
<!--                    <el-form-item prop="code" v-if="loginForm.name!=null && loginForm.name!=''">
                        <el-input type="text"  v-model="loginForm.code" id="code" auto-complete="off"  placeholder="驗證碼"
                        >
                            <el-button @click.native="validCodeSend" style="width: 120px;"
                                       :disabled="codeCount<60" slot="prepend">
                                <span>{{codeMsg}}</span>
                            </el-button>
                        </el-input>
                    </el-form-item>-->

                    <el-form-item>
                        <el-button type="primary" class="login_inactive" v-bind:class="{'login_active':isLogin}"
                                   :disabled="loginForm.name==null || loginForm.name==''
                    || loginForm.password==null || loginForm.password==''"
                                   @click.native.prevent="handleSubmit" :loading="logining">登入</el-button>
                    </el-form-item>
                </div>

                <div v-if="systemCpy==1" style="width: 1000px;position: fixed;margin-top: 10px;margin-left: -113px">
                    {{rightStr}}</div>
                <div v-if="systemCpy==2" style="width: 1000px;position: fixed;margin-top: 10px;">
                    {{rightStr}}</div>


                <!-- <div  class="login_button"><span class="info_word" @click="open(1)">免責聲明及擁有權</span> |
                     <span class="info_word" @click="open(2)">個人資料政策</span> |
                     <span class="info_word" @click="open(3)">安全性</span></div>
     -->

                <!--<div v-if="systemCpy==1" class="login_button"><span class="info_word" @click="goMail">網路郵箱</span></div>
                <div v-if="systemCpy==1" class="login_button" style="margin-top:10px"><span class="info_word" @click="goNewEnter">新版登入页面</span></div>-->


            </div>

        </el-form>

        <el-dialog :title="dialogName" :visible.sync="privateVisible" width="1200px" v-dialogDrag ref="dialog__wrapper">
            <div v-html="privateContent"></div>
        </el-dialog>
    </div>
</template>

<script>
    import { getToken,insertMsgCode,validMsgCode } from '../api/api'
    import router from '@/router/router'
    import parseMenu from '@/utils/MenuUtil'
    export default {
        data() {
            var validateName=(rule, value, callback) => {
                if (value === '') {
                    callback(new Error("帳號不能為空"));
                }else {
                    callback();
                }
            };
            var validatePwd=(rule, value, callback) => {
                if (value === '') {
                    callback(new Error("密碼不能為空"));
                }else {
                    callback();
                }
            };
            var validateCode=(rule, value, callback) => {
                if (value === '') {
                    callback(new Error("驗證碼不能為空"));
                }else {
                    if(value.length>=4){
                        let params ={nowDate: Math.round((new Date().getTime()/1000)*10000/10000),loginName:this.loginForm.name,code:this.loginForm.code};
                        validMsgCode(params).then(res=>{
                            if(res.errcode==200){
                                callback();
                            }else{
                                callback(new Error(res.errmsg));
                            }
                        }).catch((error)=>{
                            console.log("validMsgCode Error");
                            callback(new Error("validMsgCode Error"));
                        });
                    }/*else if(value=== '3838'){
                        callback();
                    }*/

                }
            };

            return {
                isLogin:false,
                options: [{
                    value: 'zh-CN',
                    label: '簡體'
                }, {
                    value: 'zh-TW',
                    label: '繁體'
                }, {
                    value: 'en-US',
                    label: 'English'
                }],
                langVal:"zh-CN",
                logining: false,
                loginForm: {
                    name: "",
                    password: ""
                },

                rules: {
                    name: [
                        { validator: validateName, trigger: 'blur' }
                    ],
                    password: [
                        { validator: validatePwd, trigger: 'blur' }
                    ],
                    code:[
                        { validator: validateCode, trigger: 'blur' }
                    ]
                },
                checked: true,
                codeCount:60,
                codeMsg:"發送驗證碼",
                codeDisabled:false,
                dialogName:"",
                privateContent:"",
                privateIndexOption:[
                    {label:'免責聲明及擁有權',value:1,content:"<p class=\"ql-align-center\">有關本網站的重要資訊</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">本網站由恒泰財資(「恒資」)所運作，此網站所有的資料僅作一般性參考，並不構成財務、醫療、投資或其他任何建議。恒資會合理地處理本網站所提供的資料，此等資料並不是為閣下的投資目標、財務狀況或特別需要而設。當本網站的資料有所更改時，恒資會在可行的情況下盡力更新有關資料。但由於資料可能在沒有通告的情況下更改，故恒資不會保證在所有情況下本網站資料的準確性，包括由第三者所提供的資料。此等資料是特別為香港居民而設並不適合於中國大陸境內使用，除非特別闡明，否則所有貨幣均以港幣計算。除非特別闡明，本網站內所提供的資料的版權由恒資所有。閣下不能以任何形式更改或修改這些資料，包括移除此版權通告。除法律不容許免除的責任外，若閣下因本網站的資料而導致任何損失、賠償、費用或其他開支，恒資不會承擔任何責任。</span></p>"},
                    {label:'個人資料政策',value:2,content:"<p>恒泰財資個人資料政策</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">恒泰財資(「恒資」) 一向重視個人私隱權，故此全力支持實施個人資料（私隱）條例。恒資的客戶、營業員及雇員，信賴本公司保障他們的個人私隱。對於他們的信賴，我們深感榮幸，並會依據下列原則，切實維護他們的私隱。&nbsp;</span></p><p><br></p><p><strong style=\"color: rgb(0, 0, 0);\">資料收集及使用</strong></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">我們只會收集有需要的資料，並會從公平的途徑去收集，及會披露一般的使用目的。</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">我們使用該等個人資料，是為了迎合我們客戶、營業員及雇員的需要及有關目的。我們會一直遵守法律，在未知會並得到有關人士同意之前，我們都不會使用該個人資料在其他用途。這是我們一直奉行的宗旨。</span></p><p><br></p><p><strong style=\"color: rgb(0, 0, 0);\">資料的質素</strong></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">我們深明個人資料的準確性之重要，並會採取所有切實可行的步驟，以確保該等個人資料之準確性。</span></p><p><br></p><p><strong style=\"color: rgb(0, 0, 0);\">保安</strong></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">我們嚴謹執行保安措施，以確保該等個人資料之機密性。只有為本公司工作的人士，在公事所需的情況下，方有權接觸該等個人資料。</span></p><p><br></p><p><strong style=\"color: rgb(0, 0, 0);\">回應要求</strong></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">對於有關查閱及更改個人資料的要求，我們會儘快作出回應。倘我們因遵從法律規定而拒絕有關要求，我們會作出解釋。</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">保障私隱是我們為客戶、營業員及雇員提供的服務之一。我們在保障私隱時，會維持最優質的服務水準，就如我們提供其他服務一樣。</span></p><p class=\"ql-align-right\">恒泰財資&nbsp;</p><p class=\"ql-align-right\">這項政策適用於恒泰保險財資服務有限公司屬下各公司</p><p><br></p>"},
                    {label:'安全性',value:3,content:"<p class=\"ql-align-center\">安全性</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">恒泰財資(「恒資」)承諾會確保閣下的私人資料保密。為確保資料的保密性，我們實行了以下的安全措施: 料的保密性，我們實行了以下的安全措施:&nbsp;</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">1. 我們會將資料儲存于一個安全網站，並使用128位加密技 術將資料加密保護, 而這個加密技術是市面上最安全的一種。 此外, 所有傳送至恒資及由恒資發出的資料都會經由 SSL (Secure Socket Layer) 安全通訊機制加密。 術將資料加密保護, 而這個加密技術是市面上最安全的一種。 此外, 所有傳送至恒泰及由恒泰發出的資料都會經由 SSL (Secure Socket Layer) 安全通訊機制加密。&nbsp;</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">2. 閣下可透過電子憑證(Electronic Certificate) 確認本網站是屬於恒泰保險財資服務有限公司所有。閣下可根據以下 資料核對: Certificate) 確認本網站是屬於恒泰保險財資服務有限公司所有。閣下可根據以下 資料核對:&nbsp;</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">資料核對:&nbsp;</span></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">Issued to = eversupport.eifs.com.hk:</span></p><p><span style=\"color: rgb(0, 0, 0);\">Issued by = GeoTrust Inc,</span></p>"},
                ],
                privateVisible:false,
                loginMsg:"<p class=\"ql-align-center\">有關本網站的重要資訊</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">本網站由恒泰財資(「恒資」)所運作，此網站所有的資料僅作一般性參考，並不構成財務、醫療、投資或其他任何建議。恒資會合理地處理本網站所提供的資料，此等資料並不是為閣下的投資目標、財務狀況或特別需要而設。當本網站的資料有所更改時，恒資會在可行的情況下盡力更新有關資料。但由於資料可能在沒有通告的情況下更改，故恒資不會保證在所有情況下本網站資料的準確性，包括由第三者所提供的資料。此等資料是特別為香港居民而設並不適合於中國大陸境內使用，除非特別闡明，否則所有貨幣均以港幣計算。除非特別闡明，本網站內所提供的資料的版權由恒資所有。閣下不能以任何形式更改或修改這些資料，包括移除此版權通告。除法律不容許免除的責任外，若閣下因本網站的資料而導致任何損失、賠償、費用或其他開支，恒資不會承擔任何責任。</span></p>",
                loginMsg2:"<p class=\"ql-align-center\">有關本網站的重要資訊</p><p><br></p><p><br></p><p><span style=\"color: rgb(0, 0, 0);\">本網站由本公司所運作，此網站所有的資料僅作一般性參考，並不構成財務、醫療、投資或其他任何建議。本公司會合理地處理本網站所提供的資料，此等資料並不是為閣下的投資目標、財務狀況或特別需要而設。當本網站的資料有所更改時，本公司會在可行的情況下盡力更新有關資料。但由於資料可能在沒有通告的情況下更改，故本公司不會保證在所有情況下本網站資料的準確性，包括由第三者所提供的資料。此等資料是特別為香港居民而設並不適合於中國大陸境內使用，除非特別闡明，否則所有貨幣均以港幣計算。除非特別闡明，本網站內所提供的資料的版權由本公司所有。閣下不能以任何形式更改或修改這些資料，包括移除此版權通告。除法律不容許免除的責任外，若閣下因本網站的資料而導致任何損失、賠償、費用或其他開支，本公司不會承擔任何責任。</span></p>",
                loginTitle:"免責聲明及擁有權",
                isHkServer:"",
                systemCpy:"",
                rightStr:"本資料乃恒泰保險財資服務有限公司之資產，恒泰保險財資服務有限公司擁有本資料全部智慧財產權。"
            };
        },
        methods: {
            goNewEnter(){
                this.$router.push('/loginEnter')
            },
            validIsLogin(){
                if(this.loginForm.code!=null && this.loginForm.code!=''
                    && this.loginForm.name!=null && this.loginForm.name!=''
                    && this.loginForm.password!=null && this.loginForm.password!=''){
                    this.isLogin=true;
                }else{
                    this.isLogin=false;
                }
            },
            goMail(){
                window.open("http://mail.eifs.com.hk/")
            },
            open(index2) {
                this.dialogName = this.privateIndexOption.find(v=>v.value==index2).label;
                this.privateContent = this.privateIndexOption.find(v=>v.value==index2).content;
                this.privateVisible = true;
            },

            //發送驗證碼
            validCodeSend(){
                if(this.codeCount==60){
                    insertMsgCode(this.loginForm.name).then(res=>{
                        if(res.errcode!=200){
                            this.$message.error(res.errmsg);
                        }
                    }).catch((error)=>{
                        console.log("insertMsgCode Error");
                    });
                }
                if (this.codeCount == 0) {
                    this.codeMsg = "發送驗證碼"
                    this.codeCount = 60;
                    return;
                } else {
                    this.codeMsg = "等待".concat(this.codeCount).concat("秒");
                    this.codeCount--;
                }
                if (this.codeCount >= 0) {
                    setTimeout(this.validCodeSend, 1000);
                }
            },
            handleReset() {
                this.$refs.loginForm.resetFields();
            },
            handleSubmit(ev) {
                this.$router.options.routes =[];
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        this.logining = true;
                        var params={name:this.loginForm.name,password:this.loginForm.password,isHkServer:this.isHkServer};
                        getToken(params).then(
                            res=>{
                                //判斷核取方塊是否被勾選 勾選則調用配置cookie方法
                                if(this.checked){
                                    //傳入帳號名，密碼，和保存天數3個參數
                                    this.setCookie(this.loginForm.name,this.loginForm.password,7);
                                }else {
                                    this.clearCookie();
                                }
                                this.logining = false;

                                if(res.errcode===200){
                                    let msg = this.loginMsg;
                                    if(this.systemCpy==1){
                                        msg = this.loginMsg2;
                                    }else if(this.systemCpy==2){
                                    }
                                    this.$confirm(msg, this.loginTitle, {
                                        confirmButtonText: '确定',
                                        cancelButtonText: '取消',
                                        dangerouslyUseHTMLString: true,
                                    }).then(() => {
                                        let {data:staff={}}=res;
                                        window.sessionStorage.setItem("staff",JSON.stringify(staff));       //將使用者存儲在session中
                                        let routes=[];
                                        parseMenu(routes,staff.menus);
                                        router.addRoutes(routes);
                                        this.$router.options.routes.push(...routes);
                                        this.$store.commit("updateStaff",staff);
                                        this.$router.push({ path: '/dashboard' });
                                        this.$store.commit("clearTabs");

                                    }).catch(() => {
                                        this.$message({
                                            type: 'info',
                                            message: '已取消登入'
                                        });
                                    });


                                }else{
                                    this.$message.error(res.errmsg);
                                }
                            },
                            err=>{
                                this.logining = false;
                            }
                        );
                    }
                });
            },
            //設置cookie
            setCookie(c_name,c_pwd,exdays) {
                var exdate=new Date();//獲取時間
                exdate.setTime(exdate.getTime() + 7*24* 60 * 60 * 1000);//保存的天數
                //字串拼接cookie
                window.document.cookie="userName"+ "=" +c_name+";path=/;expires="+exdate.toGMTString();
                //window.document.cookie="userPwd"+"="+c_pwd+";path=/;expires="+exdate.toGMTString();
            },
            //讀取cookie
            getCookie:function () {
                if (document.cookie.length>0) {
                    var arr=document.cookie.split('; ');//這裡顯示的格式需要切割一下自己可輸出看下
                    for(var i=0;i<arr.length;i++){
                        var arr2=arr[i].split('=');//再次切割
                        //判斷查找相對應的值
                        if(arr2[0]=='userName'){
                            this.loginForm.name=arr2[1];//保存到保存資料的地方
                            this.checked=true;
                        }else {
                            this.checked=false;
                        }
                        /*if(arr2[0]=='userPwd'){
                            this.loginForm.password=arr2[1];
                            this.checked=true;
                        }else {
                            this.checked=false;
                        }*/
                    }
                }
            },
            getLangCoikieKey(){
                if (document.cookie.length>0) {
                    var arr=document.cookie.split('; ');//這裡顯示的格式需要切割一下自己可輸出看下
                    for(var i=0;i<arr.length;i++){
                        var arr2=arr[i].split('=');//再次切割
                        //判斷查找相對應的值
                        if(arr2[0]=='langKey'){
                            this.langVal=arr2[1];
                            this.$i18n.locale = arr2[1];//關鍵語句
                        }
                    }
                }
            },
            //清除cookie
            clearCookie:function () {
                this.setCookie("","",-1);//修改2值都為空，天數為負1天就好了
            },
            /**
             * 切換語言
             */
            changeLangEvent(val) {
                this.$i18n.locale = val;//關鍵語句
                var exdate=new Date();//獲取時間
                exdate.setTime(exdate.getTime() + 24*60*60*1000*7);//保存的天數
                window.document.cookie="langKey"+"="+val+";path=/;expires="+exdate.toGMTString();
                this.$refs.loginForm.validate((valid) => {});
            }
        },
        mounted() {
            //獲取cookie 記住用戶名細資訊
            this.getCookie();

            //獲取國際化語言
            this.getLangCoikieKey();

            var tags=document.getElementsByTagName("*");//獲取HTML的所有標籤
            for(var i in tags){//對標籤進行遍歷
                if(tags[i].nodeType==1){//判斷節點類型
                    if(tags[i].getAttribute("id") == "loginName")//判斷ID判斷控制項
                    {
                        tags[i].focus();
                        break;
                    }
                }
            }
            let hostName = window.document.location.hostname;
            if(hostName.indexOf("esupport")>=0 || hostName.indexOf('localhost')>=0 || hostName.indexOf('www.bigthertmr')>=0){
                this.isHkServer=true;
                this.$store.commit("updateIsHkServer");
                this.systemCpy=1;
                this.$store.commit("updateSystemCpy",this.systemCpy);
            }else if(hostName.indexOf("cpver3")>=0){
                this.isHkServer=false;
            }else if(hostName.indexOf("blueoak")>=0 || hostName.indexOf('bo.bigthertmr')>=0 || hostName.indexOf('system.blueoak.com.hk')>=0){
                this.isHkServer=true;
                this.$store.commit("updateIsHkServer");
                this.systemCpy=2;
                this.$store.commit("updateSystemCpy",this.systemCpy);
                this.rightStr = this.rightStr.replace(/恒泰保險財資服務有限公司/g,"宏泰國際");
                this.privateIndexOption.forEach((v,i)=>{
                    v.content=v.content.replace(/恒泰財資/g,"宏泰國際");
                    v.content=v.content.replace(/恒資/g,"宏泰");
                    v.content=v.content.replace(/恒泰保險財資服務有限公司/g,"宏泰國際");
                    v.content=v.content.replace(/恒泰/g,"宏泰國際");

                });
                //恒泰財資(「恒資」)
                this.loginMsg = this.loginMsg.replace(/恒泰財資/g,"宏泰國際");
                this.loginMsg = this.loginMsg.replace(/恒資/g,"宏泰");
            }else if(hostName.indexOf("eifschina")>=0){
                this.isHkServer=true;
                this.systemCpy=3;
                /*this.$store.commit("updateIsHkServer");
                this.systemCpy=1;
                this.$store.commit("updateSystemCpy",this.systemCpy);*/
                this.rightStr = this.rightStr.replace(/恒泰保險財資服務有限公司/g,"中恒");
                this.privateIndexOption.forEach((v,i)=>{
                    v.content=v.content.replace(/恒泰財資/g,"中恒");
                    v.content=v.content.replace(/恒資/g,"中恒");
                    v.content=v.content.replace(/恒泰保險財資服務有限公司/g,"中恒");
                    v.content=v.content.replace(/恒泰/g,"中恒");

                });
                //恒泰財資(「恒資」)
                this.loginMsg = this.loginMsg.replace(/恒泰財資/g,"中恒");
                this.loginMsg = this.loginMsg.replace(/恒資/g,"中恒");
            }else if(hostName.indexOf("test")>=0){
                this.loginMsg = '';
                this.privateIndexOption.forEach((v,i)=>{
                    v.content='';
                });
                this.rightStr = '';
            }
        },
        computed:{
            isShowChromeTip() {
                var userAgent = navigator.userAgent; //取得流覽器的userAgent字串
                if (userAgent.indexOf("Chrome") > -1){
                    return false;
                }
                return true;
            }

        }
    }

</script>

<style lang="scss" scoped>
    .info_word{
        cursor: pointer;
        text-decoration-line: underline;
    }

    .login_button{
        text-align: center;
        margin-top: 40px;
    }

    .login_info{
        padding: 5px 30px;
        overflow: hidden;
        border: 2px ridge #f7f3ee;
        border-radius: 5px;
    }

    .login_border{
        width: 400px;
        left: 50%;
        top: 50%;
        position: absolute;
        margin: -300px 0 0 -175px;
        overflow: hidden;
    }

    .login-container {
        box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);
        background-clip: padding-box;
        width: 100%;
        overflow: hidden;
        height: 100%;
        position: absolute;

        .title {
            margin: 20px 0px;
            text-align: center;
            color: #505458;
        }
        .remember {
            margin: 15px 0px 25px 0px;
        }
    }

    .el-input__inner{padding: 0 5px;}
    .el-form-item__label{color: #000000;}

    .login_form_button{
        width: 57px;
        text-align: center;
    }

    .login_inactive{
        width:100%;
    }
    .login_active{
        width: 100%;
    }



</style>




// WEBPACK FOOTER //
// src/views/Login.vue